import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ServiceLocatorService, EventService } from '@ncs/ncs-lib';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SharedataService {
  private subject = new Subject<any>();
  private subjectAnother = new Subject<any>();

  public data: any;
  public dataOne:any={}

  constructor(
    public locator: ServiceLocatorService,
    private eService: EventService,
    public route: ActivatedRoute
  ) {}

  sendData(data: any) {
    //  console.log(data);
    this.subject.next({ data: data });
    this.data = data;
    //  console.log(this.data);
  }

  getData(): Observable<any> {
    // console.log("getData");
    // console.log(this.subject.asObservable());
    return this.subject.asObservable();
  }
  getData1() {
    // console.log('this.data ', this.data);
    return this.data;
  }

  updateSharedData(key: string, value: any) {
    this.dataOne[key] = value;   
    this.subjectAnother.next(this.dataOne); 
  }

  getSharedData(): Observable<any> {
    return this.subjectAnother.asObservable();
  }

  getSharedDataByKey(key: string) {
    return this.dataOne[key];
  }
}
